import React from 'react';
import { createComponent } from '@lit/react';

import { IconViewer } from 'icon-svg-lib';

const IconViewerReact = createComponent({
  react: React,
  tagName: 'icon-viewer',
  elementClass: IconViewer
});


function App() {
  return (
    <IconViewerReact />
  );
}

export default App;
